import { TranslationCatalog } from './translations.types';
import { AUTH_OTP_TRANSLATIONS } from './auth-otp.translations';
import { AUTH_LOGIN_TRANSLATIONS } from './auth-login.translations';
import { AUTH_PASSWORD_RESET_TRANSLATIONS } from './auth-password-reset.translations';
import { AUTH_RECOVER_TRANSLATIONS } from './auth-recover.translations';
import { AUTH_REGISTER_TRANSLATIONS } from './auth-register.translations';

export const AUTH_TRANSLATIONS: TranslationCatalog = {
  es: {
    ...AUTH_LOGIN_TRANSLATIONS.es,
    ...AUTH_PASSWORD_RESET_TRANSLATIONS.es,
    ...AUTH_RECOVER_TRANSLATIONS.es,
    ...AUTH_REGISTER_TRANSLATIONS.es,
    ...AUTH_OTP_TRANSLATIONS.es,
  },
  en: {
    ...AUTH_LOGIN_TRANSLATIONS.en,
    ...AUTH_PASSWORD_RESET_TRANSLATIONS.en,
    ...AUTH_RECOVER_TRANSLATIONS.en,
    ...AUTH_REGISTER_TRANSLATIONS.en,
    ...AUTH_OTP_TRANSLATIONS.en,
  },
};
